/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Starts_In_TodayInputs */



/**
* | output |
* | --- |
* | "today" |
*
* @param {Tournaments_Lib_Starts_In_TodayInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_starts_in_today = /** @type {((inputs?: Tournaments_Lib_Starts_In_TodayInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Starts_In_TodayInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("heute")
	if (locale === "fr") return /** @type {LocalizedString} */ ("aujourd’hui")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("今天")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("今天")
	if (locale === "ko") return /** @type {LocalizedString} */ ("오늘")
	return /** @type {LocalizedString} */ ("today")
});